/* eslint-disable import/prefer-default-export */

export const CLASSIFICATION_TYPES = {
  CONTINENT: 'continent',
  MULTICOUNTRY_REGION: 'multicountryregion',
  SUPERCOUNTRY: 'supercountry',
  COUNTRY: 'country',
  SUBCOUNTRY: 'subcountry',
  COURSE: 'course',
  DIET_TYPE: 'diettype',
  FLAVOURS: 'flavours',
  TECHNIQUE: 'technique',
  SEASON: 'season',
  FESTIVAL: 'festival',
  MONTH: 'month',
  CELEBRATIONS: 'celebrations',
  CUISINE: 'cuisine',
  BOOK_SPECIFIC: 'bookspecific',
  SKILL: 'skill',
  HOME_CONNECT: 'homeconnect',
};

export const VALID_APPLIANCE_TYPES = ['oven', 'steamer', 'sousvide', 'immersion circulator'];

export const APPLIANCE_CONFIG = {
  type: VALID_APPLIANCE_TYPES,
  oven: {
    setting: {
      roundToNearest: 5,
      temperature_c: {
        max: 300,
        min: 20,
      },
      temperature_f: {
        max: 580,
        min: 65,
      },
      mode: {
        bake: 'Bake',
        bakingstone: 'Baking stone function',
        bottomheat: 'Bottom heat',
        bottomheating: 'Bottom heat',
        breadbaking: 'Bread Baking',
        circoroast: 'CircoRoast',
        circotherm: 'CircoTherm',
        circothermintensive: 'CircoTherm Intensive',
        cook: 'Heat',
        defrosting: 'Defrosting',
        fourdhotair: '4D Hot Air',
        fullgrill01steam: 'Full surface grill level 1 + humidity',
        fullgrill02steam: 'Full surface grill level 2 + humidity',
        fullsteam: 'Full Steam',
        grill: 'Grill',
        heat: 'Cook',
        hotair: 'Hot Air',
        hotair100steam: 'Hot air with 100% humidity',
        hotair30steam: 'Hot air with 30% humidity',
        hotair60steam: 'Hot air with 60% humidity',
        hotair80steam: 'Hot air with 80% humidity',
        hotairbottomheat: 'Hot air + bottom heat',
        hotaireco: 'Hot Air Eco',
        hotairthirdbottomheat: 'Hot air + ⅓ bottom heat',
        keepwarm: 'Keep Warm',
        lowtemperature: 'Low Temperature',
        off: 'Off',
        pizza: 'Pizza',
        preheat: 'Preheat',
        prove: 'Prove',
        regenerating: 'Regenerating',
        roast: 'Roast',
        roaster: 'Roaster function',
        steam: 'Steam',
        thirdtopbottomheat: '⅓ Top + bottom heat',
        topbottomheat: 'Top-bottom heat',
        topbottomheating: 'Top-bottom heat',
        topheat: 'Top heat',
        topthirdbottomheat: 'Top + ⅓ bottom heat',
        warm: 'Warm',
      },
    },
    duration: {
      value: {
        max: 6 * 60 * 60,
        min: 30,
      },
    },
  },
  sousvide: {
    setting: {
      roundToNearest: null,
      temperature_c: {
        max: 100,
        min: 30,
      },
      temperature_f: {
        max: 210,
        min: 85,
      },
      mode: { preheat: 'Sous vide (preheat)', heat: 'Sous vide' },
    },
    duration: {
      value: {
        max: 72 * 60 * 60,
        min: 60,
      },
    },
  },
  steamer: {
    setting: {
      roundToNearest: 5,
      temperature_c: {
        max: 100,
        min: 30,
      },
      temperature_f: {
        max: 210,
        min: 85,
      },
      mode: { fullsteam: 'Full Steam', steam: 'Steam', heat: 'Steam' },
    },
    duration: {
      value: {
        max: 6 * 60 * 60,
        min: 30,
      },
    },
  },
};

export const APPLIANCE_ISSUES = {
  ACTION_NOT_FOR_OVEN: 'ACTION_NOT_FOR_OVEN',
  DURATION_HIGH_VALUE_NOT_SET: 'DURATION_HIGH_VALUE_NOT_SET',
  DURATION_NOT_RELEVANT: 'DURATION_NOT_RELEVANT',
  INFEASIBLE_TEMPERATURE: 'INFEASIBLE_TEMPERATURE',
  INVALID_DURATION: 'INVALID_DURATION',
  INVALID_SETTING_MODE: 'INVALID_SETTING_MODE',
  LONE_PREHEAT: 'LONE_PREHEAT',
  MISSING_ADJUSTMENT: 'MISSING_ADJUSTMENT',
  MISSING_DURATION: 'MISSING_DURATION',
  MISSING_FAN_TEMPERATURE: 'MISSING_FAN_TEMPERATURE',
  MISSING_OR_WRONG_INSTRUCTION: 'MISSING_OR_WRONG_INSTRUCTION',
  MISSING_PREHEAT: 'MISSING_PREHEAT',
  MISSING_SETTING: 'MISSING_SETTING',
  MULTIPLE_PREHEATS: 'MULTIPLE_PREHEATS',
  PREHEAT_MID_RECIPE: 'PREHEAT_MID_RECIPE',
  UNSUPPORTED_ADJUSTMENT_TYPE: 'UNSUPPORTED_ADJUSTMENT_TYPE',
  WRONG_TEMPERATURE_UNIT: 'WRONG_TEMPERATURE_UNIT',
  MISSING_OVENY_VERB: 'MISSING_OVENY_VERB',
};

export const defaultCollectionsTabs = [
  { title: 'My Collections', tag: 'mine', href: '/collections' },
  { title: 'Featured', tag: 'featured', href: '/collections/featured' },
  { title: 'Ingredients', tag: 'ingredients', href: '/collections/ingredients/az' },
  { title: 'Community', tag: 'community', href: '/collections/community' },
];
